import { useSubtitleFilters } from "app/custom-hooks/useSubtitleFilters";
import { WidgetContainer } from "app/components/React/WidgetContainer/WidgetContainer";
import { translate } from "app/filters/i18nFilter";

import { useMarketingChannelsServices } from "./common/useMarketingChannelsServices";
import type { ApiOvertimeData } from "./TrafficShareBarChart/types";
import { TrafficVolumesLineChart } from "./TrafficVolumesLineChart/TrafficVolumesLineChart";
import { usePngExport } from "./TrafficVolumesLineChart/utils/useTrafficVolumesChartPngExport";

interface IMarketingChannelsTrafficVolumesBySourceWidgetProps {
    isLoading: boolean;
    apiData: ApiOvertimeData;
}

export const MarketingChannelsTrafficVolumesBySourceWidget = ({
    isLoading,
    apiData,
}: IMarketingChannelsTrafficVolumesBySourceWidgetProps) => {
    const subtitleFilters = useSubtitleFilters("date", "country", "webSource");
    const { services } = useMarketingChannelsServices();
    const { widgetRef, handlePNGExport } = usePngExport(services);

    const shouldShowNoData = Boolean(apiData == null && !isLoading);

    return (
        <div ref={widgetRef}>
            <WidgetContainer
                withBorder
                automationId="traffic-volumes-line-chart"
                title={translate("industry.trafficsources.graph.title")}
                tooltip={translate("industry.trafficsources.graph.title.tooltip")}
                noData={shouldShowNoData}
                subtitleFilters={subtitleFilters}
                onDownloadClick={handlePNGExport}
            >
                <TrafficVolumesLineChart
                    isLoading={isLoading}
                    apiData={apiData}
                />
            </WidgetContainer>
        </div>
    );
};
